export default __webpack_public_path__ + "static/media/stillLife.ca5f9ac2.png";